 import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { NavLink } from "react-router-dom";
import "./blogs.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ArrowRight from "./ArrowRight.svg";
import ArrowLeft from "./ArrowLeft.svg";

const NextArrow = ({ onClick }) => (
  <button className="blogsCarousel-arrow blogsCarousel-next" onClick={onClick}>
    <img src={ArrowRight} alt="Next" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="blogsCarousel-arrow blogsCarousel-prev" onClick={onClick}>
    <img src={ArrowLeft} alt="Previous" />
  </button>
);

const BlogsCarousel = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/events`);
      // Sort newest first
      const sorted = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      console.log("Fetched events for carousel:", sorted);
      setEvents(sorted);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const settings = {
  dots: false,
  infinite: events.length > 3, // only loop if more than 3 events
  speed: 500,
  slidesToShow: events.length < 3 ? events.length : 3, // show only what’s available
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: events.length < 2 ? events.length : 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


  return (
    <div className="blogsCarousel-wrapper">
      <h2 className="blogsCarousel-title">Events</h2>

      {events.length === 0 ? (
        <p className="no-events-msg">No events available.</p>
      ) : (
        <Slider {...settings}>
          {events.map((event) => (
            <div key={event._id} className="blogsCarousel-slide">
              <div className="blogsCarousel-card">
                <div className="blogsCarousel-imgContainer">
                  <img src={event.image} alt={event.title} loading="lazy" />
                </div>
                <h3 className="blogsCarousel-cardTitle">{event.title}</h3>
                <p className="blogsCarousel-desc">
                  {event.shortDescription?.slice(0, 120)}...
                </p>
                <p className="blogsCarousel-date">
                  🗓️{" "}
                  {new Date(event.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </p>
                <NavLink to={`/event/${event._id}`}>
                  <button className="blogsCarousel-readBtn">READ MORE</button>
                </NavLink>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default BlogsCarousel;
